import {GAMES} from "../enums/EiaEnums";

//objectWithMetaInformation kann auction, bid oder cookies sein
export const getGameRequest = function(objectWithMetaInformation) {
    //TODO depreacted ab season 12 müssen alle auctions korrekte Werte haben ohne diese Defaults
    const game = objectWithMetaInformation && objectWithMetaInformation.game ? objectWithMetaInformation.game : GAMES[0];
    const platform = objectWithMetaInformation && objectWithMetaInformation.platform ? objectWithMetaInformation.platform : "ALL";
    const region = objectWithMetaInformation && objectWithMetaInformation.region ? objectWithMetaInformation.region : "EUROPE";
    const mode = objectWithMetaInformation && objectWithMetaInformation.mode ? objectWithMetaInformation.mode : "SOFTCORE";
    const realm = objectWithMetaInformation && objectWithMetaInformation.realm ? objectWithMetaInformation.realm : "SEASON";

    return {
        game: game,
        platform: platform,
        region: region,
        mode: mode,
        realm: realm
    }
}
